var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout-wrapper"}},[_c('NavBar',{attrs:{"isCondensed":_vm.isMenuCondensed}}),_c('SideBar',{attrs:{"isCondensed":_vm.isMenuCondensed}}),_c('div',{staticClass:"main-content min-vh-100"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)]),_c('Footer')],1),_c('WhatsApp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }